import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

//components
import { Home } from "./pages/home";
import Diseases from "./pages/diseases";
import DiseasesDetails from "./pages/diseasesDetails";
import About from "./pages/about";
import MainDiagnosis from "./components/diagnosis/mainDiagnosis";
import Blogs from "./pages/blogs";
import BlogsDetails from "./pages/blogsDetails";

const App = () => {
  const [viewDiagnosis, setViewDiagnosis] = useState(false);
  return (
    <div>
      <Router>
        <MainDiagnosis
          viewDiagnosis={viewDiagnosis}
          setViewDiagnosis={setViewDiagnosis}
        />
        <Routes>
          <Route
            path="/"
            element={<Home setViewDiagnosis={setViewDiagnosis} />}
          />
          <Route
            path="/diseases"
            element={<Diseases setViewDiagnosis={setViewDiagnosis} />}
          />
          <Route
            path="/diseases/:id"
            element={<DiseasesDetails setViewDiagnosis={setViewDiagnosis} />}
          />
          <Route
            path="/about-us"
            element={<About setViewDiagnosis={setViewDiagnosis} />}
          />
          <Route
            path="/blogs"
            element={<Blogs setViewDiagnosis={setViewDiagnosis} />}
          />
          <Route
            path="/blogs/:id"
            element={<BlogsDetails setViewDiagnosis={setViewDiagnosis} />}
          />
        </Routes>
      </Router>
    </div>
  );
};

export default App;
